/*
 * Copyright (c) 2021.  Blacksheepz media B.V.
 * https://www.blacksheepz-media.com
 * Ramon van Ophuizen
 */
import React, { useEffect, useState } from 'react'

import { ContextProviders } from './context/ContextProviders'
import CustomRouter from './components/CustomRouter'
import { useConfigClient } from './config/apolloConfig'
import { ApolloProvider } from '@apollo/client'

/* App Controller*/
function App () {

  document.addEventListener('contextmenu', event => event.preventDefault())

  const [jwtState, setJwtState] = useState('')

  useEffect(() => {
  }, [jwtState])

  return (
    <ApolloProvider client={useConfigClient(jwtState)}>
      <ContextProviders setJwtState={setJwtState}>
        <CustomRouter/>
      </ContextProviders>
    </ApolloProvider>
  )

}

export default React.memo(App);

